import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const LogoMark = ({ size = 22, light = false }) => {
  const bolt = "0,26 8,6 16,6 8,26";
  return (
    <svg width={size * 2} height={size} viewBox="0 0 64 32" aria-hidden="true" data-testid="logo-mark">
      {[0, 1, 2, 3].map((i) => (
        <motion.polygon
          key={i}
          points={bolt}
          transform={`translate(${i * 18 - (i === 3 ? 6 : 0)} 0)`}
          fill={i === 3 ? (light ? "#ffffff" : "#181510") : "#FBBE37"}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.12 * i, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        />
      ))}
    </svg>
  );
};

export const Wordmark = ({ className = "text-xl", light = false }) => (
  <span className={`font-anton uppercase leading-none tracking-tight ${className}`} data-testid="logo-wordmark">
    <span className="text-amber">4TH</span>
    <span className={light ? "text-white" : "text-cream"}>SCENERY</span>
  </span>
);

export const Logo = ({ light = true }) => (
  <Link to="/" className="flex items-center justify-center" data-testid="logo-link" aria-label="4thscenery home">
    <span className="relative inline-block">
      <img
        src="/media/logo-agency.png"
        alt="4thscenery Agency"
        className={`h-10 w-auto transition-opacity duration-500 md:h-14 ${light ? "opacity-100" : "opacity-0"}`}
        data-testid="logo-image"
      />
      <img
        src="/media/logo-agency-dark.png"
        alt=""
        aria-hidden="true"
        className={`absolute inset-0 h-10 w-auto transition-opacity duration-500 md:h-14 ${light ? "opacity-0" : "opacity-100"}`}
      />
    </span>
  </Link>
);
